import { render, staticRenderFns } from "./NewComercialRequest.vue?vue&type=template&id=5560dfed&"
import script from "./NewComercialRequest.vue?vue&type=script&lang=js&"
export * from "./NewComercialRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports